import { splitDigitRuns } from '../format.js';

/** Text whose digit runs are rendered with tabular numerals (`sk-num`). */
export function Digits({ children }: { children: string }) {
  return (
    <>
      {splitDigitRuns(children).map((part, index) =>
        part.numeric ? (
          <span key={index} className="sk-num">
            {part.text}
          </span>
        ) : (
          part.text
        ),
      )}
    </>
  );
}
